import { Box, BoxProps, TableProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../common/table/types';

/**
 * Returns a component for use in a table cell with the given formatting options
 * @param value 
 * @param isStrong 
 * @param align 
 * @param emptyValue placeholder to use when the value is empty.
 *  Allows to set something else than the default when 0 should not be defaulted to '-'.
 * @returns 
 */
export const getCell = (
    value: JSX.Element | string | number | undefined,
    isStrong = false,
    align: BoxProps.Float = 'right',
    emptyValue = constants.EMPTY_VALUE_PLACEHOLDER,
): JSX.Element => {

    const text = value || emptyValue;
    return isStrong ? <Box variant='strong' float={align}>{text}</Box> : <Box float={align}>{text}</Box>;
};
interface TableFormattedHeaderProps {
    columnType: ColumnTypes;
    text: string;
}

const TableFormattedHeader = (props: TableFormattedHeaderProps) => {
    // TODO: add localization here; ex: for countries where reading is from right to left.
    const textAlign = props.columnType === ColumnTypes.NUMBER ? 'right' : 'left';
    return (<Box fontWeight='bold' textAlign={textAlign}>{props.text}</Box>);
};

/**
 * Sets formatting for table headers: bold font and right/left alignment base on column type.
 * @param tableHeaders headers to format.
 * @returns the formatted headers.
 */
export function formattedTableHeaders<T> (tableHeaders: ColumnDefinition<T>[]):
    TableProps.ColumnDefinition<T>[] {
    return (
        tableHeaders.map(item => (
            {
                ...item,
                header: <TableFormattedHeader text={item.header as string} columnType={item.type}/>
            }
        ))
    );
}
